import {
  convertToLocalStyle,
  glyphIconStyle,
  helpbuttonStyle,
  uiblockerStyle,
  sharedBudgetGridWrapper,
  containerBudgetStyle,
} from '@bingads-webui-campaign-react/common-styles';

export const getBudgetStyles = (_, { palette }) => ({
  '@global': {
    ...uiblockerStyle({ palette }),
  },
  pickerContainer: {
    ...containerBudgetStyle({ palette }),
    ...sharedBudgetGridWrapper({ palette }),
    ...convertToLocalStyle(glyphIconStyle({ palette })),
    ...convertToLocalStyle(helpbuttonStyle({ palette })),
    '& .displayNone': {
      display: 'none',
    },
  },
  budgetHeader: {
    marginBottom: 6,
  },
});
